<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <div class="header-content">
      <h2 ngpDialogTitle class="modal-title">
        {{ "swap-widget-dialog.title" | translate }}
      </h2>
      <span class="current-widget-name">{{ widget.title }}</span>
    </div>

    <sui-button
      size="sm"
      variant="danger"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="swap-widget-content">
      <div class="filter-controls">
        <app-search-input
          [placeholder]="'widget-sidebar.search.placeholder' | translate"
          (inputChanged)="handleInputChange($event)"
        ></app-search-input>

        <sui-combobox
          class="group-select"
          [options]="groupOptions"
          [ngModel]="selectedPresetGroupId"
          (ngModelChange)="onGroupChange($event)"
          [dropdownContainer]="dropdownBoundary"
        ></sui-combobox>
      </div>

      <div class="preset-list">
        <app-loading *ngIf="widgetPresetsLoading$ | async"></app-loading>

        <ng-container *ngIf="widgetPresetsFiltered.length > 0; else noPresets">
          <app-widget-preset-card
            *ngFor="
              let widgetPreset of widgetPresetsFiltered | sort: 'display_order'
            "
            [widgetPreset]="widgetPreset"
            [highlight]="searchString"
            [selectedPresetId]="selectedPresetId"
            [selectedChartTypeId]="selectedChartTypeId"
            (onWidgetPreview)="onWidgetPreview($event)"
          ></app-widget-preset-card>
        </ng-container>

        <ng-template #noPresets>
          <p class="no-presets-message">
            {{ "widget-sidebar.message.no-presets-available" | translate }}
          </p>
        </ng-template>
      </div>
    </div>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>

    <sui-button
      variant="primary"
      [disabled]="!selectedEvent"
      (click)="confirm()"
    >
      {{ "swap-widget-dialog.button.swap" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
